import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErisFormFieldType } from 'eris-forms';
import { ScreeningChecklistInstance } from '../../../inspection/shared/models/Inspection';
import { InspectionService } from '../../../inspection/shared/services/inspection.service';

@Component({
  selector: 'app-checklists',
  templateUrl: './checklists.component.html',
  styleUrls: ['./checklists.component.css']
})
export class ChecklistsComponent extends ErisFormFieldType implements OnInit, AfterViewInit {

  public checklists: ScreeningChecklistInstance[] = [];
  constructor(private inspectionService: InspectionService, private cdr: ChangeDetectorRef) {
    super();
   }

  ngOnInit(): void {
    this.loadChecklists();
  }

  ngAfterViewInit(): void {
  }

  loadChecklists(){
    this.form.parent.get(this.field.templateOptions.dependsOnField)?.valueChanges.subscribe(() => {
      // wait for the templateOption to get the latest value...
      setTimeout(() => {
        let urlParam = this.field.templateOptions.extraData.urlParameter;
        let editing = this.field.templateOptions.extraData.editing;
        this.inspectionService.getData(this.field.templateOptions.dataSourceFn(urlParam).url).subscribe(checklistRefs => {
          const checklistFormGroup =  this.field.form as FormGroup;
          this.checklists = [];
            Object.keys(checklistFormGroup.controls).forEach(control => {
              if(control != "screeningChecklists"){
                checklistFormGroup.removeControl(control);
              }
            });
          if(!editing){                   
            checklistRefs.forEach(checklist => {
            this.checklists.push(new ScreeningChecklistInstance(checklist));
            checklistFormGroup.addControl(checklist.id.toString(), new FormControl("", [Validators.required]));
            });
          } else {
            let existingChecklistInsts = this.field.formControl.value as ScreeningChecklistInstance[];
            checklistRefs.forEach(checklist => {
              let checkInst = existingChecklistInsts.find(sci => sci.checklist.id == checklist.id);
              if(checkInst){
                this.checklists.push(checkInst);
                checklistFormGroup.addControl(checklist.id.toString(), new FormControl(checkInst.checklistValue.name, [Validators.required]));
              } else {
                this.checklists.push(new ScreeningChecklistInstance(checklist));
                checklistFormGroup.addControl(checklist.id.toString(), new FormControl("", [Validators.required]));
              }   
            });
          }
          
          this.cdr.detectChanges();
        });
      }, 500);
    });
  }

  onRadioButtonChange(value, checklistRefId){
    this.checklists.find(c => c.checklist.id == checklistRefId).checklistValue.name = value;
    if(this.checklists.findIndex(c => !c.checklistValue.name) == -1){
      this.field.formControl.setValue(this.checklists);
    }  
  }
}
